import { Autocomplete } from 'src/components/Autocomplete';
import { Chip } from 'src/components/Chip';
import { TextField } from 'src/components/TextField';

interface SubscriptionTypeFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
}

const subscriptionTypes = [
  { id: 'pending_cancel', name: 'Active - Pending Cancellation' },
  { id: 'paused', name: 'Active - Renewal Paused' },
  { id: 'current', name: 'Active - Renewing' },
  { id: 'scheduled', name: 'Scheduled for Future Start' },
];

export const SubscriptionTypeFilter: React.FC<SubscriptionTypeFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedValues = value ? String(value).split(',') : [];

  if (valueOnly) {
    return selectedValues.length > 0 ? (
      <>
        {selectedValues
          .map(
            (v) =>
              subscriptionTypes.find((option) => option.id === v)?.name || ''
          )
          .join(', ')}
      </>
    ) : null;
  }

  const selectedOptions = selectedValues.map(
    (v) =>
      subscriptionTypes.find((option) => option.id === v) || { id: v, name: v }
  );

  return (
    <Autocomplete
      multiple
      options={subscriptionTypes}
      getOptionLabel={(option) =>
        typeof option === 'string'
          ? subscriptionTypes.find((o) => o.id === option)?.name || option
          : option.name
      }
      value={selectedOptions}
      onChange={(_, newValue) => {
        setValue(
          newValue.map((v) => (typeof v === 'string' ? v : v.id)).join(',')
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Select Subscription Type"
        />
      )}
      renderTags={(value: readonly any[], getTagProps) =>
        value.map((option: any, index: number) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              label={typeof option === 'string' ? option : option.name}
              key={key}
              {...tagProps}
            />
          );
        })
      }
    />
  );
};
